import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

import { AdvertisementListItemDto, CategoryDto } from '../../api';
import { CachedCategoriesService } from '../../shared/cached-categories.service';
import { AdvertisementChipsComponent } from '../advertisement-chips/advertisement-chips.component';

@Component({
  selector: 'app-advertisement-hotspot',
  imports: [AdvertisementChipsComponent, MatIconModule, MatButtonModule, RouterLink, TranslocoDirective, MatChip],
  templateUrl: './advertisement-hotspot.component.html',
  styleUrl: './advertisement-hotspot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvertisementHotspotComponent {
  ad = input.required<AdvertisementListItemDto>();
  categories = input.required<Map<number, CategoryDto>>();
  private categoriesService = inject(CachedCategoriesService);
  imageUrl: Signal<{ url: string; isSectorImage: boolean }> = computed(() => {
    const ad = this.ad();
    const url = ad.cover_media?.url;
    if (!url) {
      return this.categoriesService.getCategoryImage(ad.category_id);
    }
    return { url, isSectorImage: false };
  });
}
